import Marquee from "react-fast-marquee";
import { BUSINESS } from "@/lib/data";

export default function BrandMarquee() {
  return (
    <section data-testid="brand-marquee-section" className="border-y border-white/10 bg-[#171B20]/60 py-8 overflow-hidden">
      <p className="text-center font-mono text-[10px] uppercase tracking-[0.35em] text-[#606D7A] mb-6 px-4">
        Factory-trained on the world's finest brands
      </p>
      <Marquee speed={28} gradient gradientColor="#12161a" gradientWidth={120}>
        {BUSINESS.brands.map((b) => (
          <div key={b} className="flex items-center gap-10 mx-10">
            <span className="font-display text-2xl font-semibold tracking-wide text-[#F4F2EE]/70">{b}</span>
            <span className="w-2 h-2 rotate-45 bg-[#E06A26]/70" />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
